// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"styles_languageSwitcher__78JOq","languageShort":"styles_languageShort__WuOZP"};